import type { App } from 'vue';
import {
  HeartOutlined,
  HistoryOutlined,
  FormOutlined,
  TableOutlined,
  AppstoreAddOutlined,
  UnorderedListOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  HomeOutlined,
  LinkOutlined,
  SettingOutlined,
  LaptopOutlined,
  CodeSandboxOutlined,
  DatabaseOutlined,
  CreditCardOutlined,
  FundProjectionScreenOutlined,
  ReconciliationOutlined
} from '@ant-design/icons-vue';

export const useIcons = (app: App) => {
  app.component(LaptopOutlined.displayName, LaptopOutlined);
  app.component(SettingOutlined.displayName, SettingOutlined);
  app.component(HeartOutlined.displayName, HeartOutlined);
  app.component(HistoryOutlined.displayName, HistoryOutlined);
  app.component(FormOutlined.displayName, FormOutlined);
  app.component(TableOutlined.displayName, TableOutlined);
  app.component(AppstoreAddOutlined.displayName, AppstoreAddOutlined);
  app.component(UnorderedListOutlined.displayName, UnorderedListOutlined);
  app.component(WarningOutlined.displayName, WarningOutlined);
  app.component(CheckCircleOutlined.displayName, CheckCircleOutlined);
  app.component(HomeOutlined.displayName, HomeOutlined);
  app.component(LinkOutlined.displayName, LinkOutlined);
  app.component(CodeSandboxOutlined.displayName, CodeSandboxOutlined);
  app.component(DatabaseOutlined.displayName, DatabaseOutlined);
  app.component(CreditCardOutlined.displayName, CreditCardOutlined);
  app.component(FundProjectionScreenOutlined.displayName, FundProjectionScreenOutlined);
  app.component(ReconciliationOutlined.displayName, ReconciliationOutlined)

};
